export default {
  PAYMENT_LINKS_LOADING: 'PAYMENT_LINKS_LOADING',
  PAYMENT_LINKS_FETCHED: 'PAYMENT_LINKS_FETCHED',
  PAYMENT_LINK_CREATING: 'PAYMENT_LINK_CREATING',
  PAYMENT_LINK_CREATED: 'PAYMENT_LINK_CREATED',
  PAYMENT_LINK_DETAIL_FETCHED: 'PAYMENT_LINK_DETAIL_FETCHED',
  PAYMENT_LINK_UPDATED: 'PAYMENT_LINK_UPDATED',
  PAYMENT_LINK_DELETED: 'PAYMENT_LINK_DELETED',
};
